import { ref, watch } from 'vue'
import axios from './Axios';
import { addProcess } from './Processor';

class RoleApi {
    constructor() {
        this.isDirty = ref(false);
        this.isLoading = ref(false);
        this.isSaving = false;

        if (!window.Api)
            window.Api = {};
        window.Api.RoleAxi = axios;
        window.Api.Role = this;
    }

    // eslint-disable-next-line
    async beforeSave(data) {
    }

    // eslint-disable-next-line
    async afterLoad(data) {
    }

    async get(id) {
        this.isLoading.value = true;
        let result = await axios.get('/api/roles/' + id);
        await this.afterLoad(result.data);
        return result.data;        
    }

    async getAll() {
        this.isLoading.value = true;
        let result = (await axios.getBuffered('/api/roles/')).data;
        await this.afterLoad(result);
        this.isLoading.value = false;
        return result;
    }

    async createNew(defaultValues) {
        let data = {
            name: '',
            description: '',
            isSuperAdmin: false,
            isSystemRole: false,
            permissionKeys: []
        };

        if (defaultValues)
            Object.assign(data, defaultValues);

        return data;
        //return this.attachWatchers(data);
    }

    async save(data) {
        let process = addProcess("Save Role: " + (data.Name || data._id || 'new'));
        await this.beforeSave(data);
        let result = await axios.post('/api/roles/', data).finally(() => process());
        return result.data;
    }

    async delete(data) {
        let key = data;
        if (typeof (data) === "object")
            key = data._id;

        let process = addProcess("Delete Role: " + ((typeof data === "object" && data.Name) ? data.Name : key));

        let result = await axios.delete('/api/roles/' + key).finally(() => process());

        return result.data;

    }

    attachWatchers(data) {
        if (Array.isArray(data))
            return data.map(i => this.attachWatchers(i));

        let dataRef = ref(data);
        this.isLoading.value = false;

        watch(dataRef.value, async () => {
            if (this.isSaving)
                return;

            this.isDirty.value = true;
            this.isSaving = true;

            let newData = await this.save(dataRef.value);
            Object.assign(dataRef.value, newData);

            setTimeout(() => {
                this.isSaving = false;
            }, 1);

            this.isDirty.value = false;
        });

        return dataRef.value;
    }
}

let roleApi = new RoleApi();

export { roleApi, RoleApi }
export default roleApi;